angular.module("vgresiduos").controller("disposalHistoryCtrl", [
	"$rootScope",
	function ($rootScope) {
		"use strict";

		this.$onInit = function () {
			Vgr.util.redirectSingleton($rootScope, `historico-destinacoes`);
		};
	}
]);
